import Dexie, { type Table } from 'dexie'

export interface VaultRow {
  id: 'singleton'
  salt: Uint8Array
  wrappedDEK: Uint8Array
  verification: Uint8Array
  createdAt: number
}

export interface BookRow {
  id: string
  createdAt: number
  encryptedPayload: Uint8Array
}

export interface GarmentRow {
  id: string
  bookId: string
  createdAt: number
  encryptedPayload: Uint8Array
}

export interface SizeChartRow {
  id: string
  garmentId: string
  createdAt: number
  encryptedPayload: Uint8Array
}

export interface ProjectRow {
  id: string
  garmentId: string
  type: 'made-to-measure' | 'size-chart'
  createdAt: number
  updatedAt: number
  encryptedPayload: Uint8Array
}

export interface PatternRow {
  id: string
  projectId: string
  version: number
  createdAt: number
  encryptedPayload: Uint8Array
}

export interface BrandingRow {
  id: 'singleton'
  encryptedPayload: Uint8Array
}

export interface SettingsRow {
  id: 'singleton'
  encryptedPayload: Uint8Array
}

export class RDStudioDB extends Dexie {
  vault!: Table<VaultRow, string>
  books!: Table<BookRow, string>
  garments!: Table<GarmentRow, string>
  sizeCharts!: Table<SizeChartRow, string>
  projects!: Table<ProjectRow, string>
  patterns!: Table<PatternRow, string>
  branding!: Table<BrandingRow, string>
  settings!: Table<SettingsRow, string>

  constructor() {
    super('cartamodelli')
    this.version(1).stores({
      vault: '&id',
      books: '&id, createdAt',
      garments: '&id, bookId, createdAt',
      sizeCharts: '&id, garmentId, createdAt',
      projects: '&id, garmentId, createdAt, updatedAt',
      patterns: '&id, projectId, version, createdAt',
      branding: '&id',
      settings: '&id',
    })
  }
}

export const db = new RDStudioDB()
